module.exports = __webpack_public_path__ + "static/media/Group-775.6115e389.png";